import clsx from "clsx";
import { MetricsItem } from "./MetricsItem";

export const MetricsList = ({ metrics, className }) => {
  return (
    <div className={clsx("metrics", className)}>
      {metrics.map(item => (
        <MetricsItem key={item.label} {...item} />
      ))}
    </div>
  );
};
